import React from "react";
import "./mainExamples.css";
import { useTranslation } from "react-i18next";
import { Image } from "antd";
import { IMAGESWORKS } from "../../../data/constants";

export default function MainExamples() {
    const { t } = useTranslation();

    return (
        <div className="main__examples">
            <div className="main__examples__container">
                <div className="main__examples__title">
                    <p>{t("main_examples_title")}</p>
                </div>
                <div className="main__examples__block">
                    {IMAGESWORKS.map((item, index) => (
                        <div className="images__works__container" key={index}>
                            <Image
                                src={item}
                                alt="photo_work"
                                width={450}
                                height={300}
                                style={{
                                    borderRadius: "1rem",
                                    boxShadow: "4px 12px 12px #0920f060",
                                }}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
